<template>
  <one-column-sidebar-left
      :id="$route.params.id"
      :type="$route.params.type"
      :tab-selector="$route.params.type + 'tab'"
      :back-button-tab-selector="$route.params.type + 'backbutton'"
  >
    <template slot="mainContent">
      <version-browser
        :type="contentTypes[$route.params.type]"
        :subtype="$route.params.type"
        :id="$route.params.id"
      />
    </template>
  </one-column-sidebar-left>
</template>

<script>
import OneColumnSidebarLeft from "@/layouts/OneColumnSidebarLeft";
import VersionBrowser from "@/components/versions/VersionBrowser";
import {contentTypes} from "@/enum";
export default {
  name: "FileBrowserView",
  components: {
    OneColumnSidebarLeft,
    VersionBrowser
  },
  data() {
    return {
      contentTypes: contentTypes,
    };
  },
  beforeMount() {
    //console.log(contentTypes[this.$route.params.type]);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>